/* eslint-disable indent */
import React, { useEffect, useState } from 'react';
import * as PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Tooltip from '../Tooltip/Tooltip';

const ShortlistButton = ({
  onClick,
  loading = false,
  isShortlisted = false,
  isInvestorsPage = false,
  variant = 'default'
}) => {
  const { t } = useTranslation();
  const [isTouchDevice, setIsTouchDevice] = useState(null);

  useEffect(() => {
    const touch =
      // eslint-disable-next-line no-undef
      'ontouchstart' in window || (navigator.maxTouchPoints || 0) > 0;
    setIsTouchDevice(touch);
  }, []);

  const button = (
    <button
      onClick={onClick}
      type="button"
      disabled={loading}
      aria-pressed={isShortlisted}
      aria-label={
        isShortlisted
          ? t('proposalsMacro.shortlisted')
          : t('proposalsMacro.shortlistAdd')
      }
      className={`
        p-1.5
        w-8
        h-8
        rounded-md
        shortlist-proposal          
        ${
          variant === 'overlay'
            ? 'bg-white/90 hover:bg-white shadow-sm'
            : 'bg-gray-200 hover:bg-gray-300'
        }
        ${
          isShortlisted
            ? variant === 'overlay'
              ? 'text-blue-600'
              : 'bg-gray-300 text-blue-600'
            : 'text-gray-700'
        }
        inline-flex
        items-center
        justify-center
        focus:outline-hidden
      `}
    >
      {loading ? (
        <svg
          className="animate-spin inline h-3.5 w-3.5 text-gray-600 fill-current"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <title>Shortlist</title>
          <path
            className="opacity-75"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          />
        </svg>
      ) : (
        <span className="text-xl material-icons">bookmark</span>
      )}
    </button>
  );

  return isTouchDevice ? (
    button
  ) : (
    <Tooltip
      text={
        isShortlisted
          ? t('proposalsMacro.shortlisted')
          : t('proposalsMacro.shortlistAdd')
      }
      classNames={
        variant === 'overlay'
          ? 'whitespace-nowrap left-1/2 bottom-full mb-2 -translate-x-1/2'
          : isInvestorsPage
          ? `whitespace-nowrap ${
              isShortlisted ? 'md:left-1/2 -left-1/4' : 'left-1/2'
            } -translate-x-1/2`
          : ''
      }
    >
      {button}
    </Tooltip>
  );
};

export default ShortlistButton;

ShortlistButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  isShortlisted: PropTypes.bool,
  isInvestorsPage: PropTypes.bool,
  variant: PropTypes.oneOf(['default', 'overlay'])
};
